import { Component } from "@angular/core";

@Component({
  selector: "vertical-divider",
  standalone: true,
  templateUrl: "./vertical-divider.component.html",
  styleUrls: ["./vertical-divider.component.scss"],
})
export class VerticalDividerComponent {}
